import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../../api/auth";
import { DEFAULT_BRANDING } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { useInvalidateMe } from "../../shared/hooks/useMe";
import { safeReturnTo } from "../../shared/returnTo";
import { Alert, Spinner } from "../../ui";

export function LogoutPage() {
  const [search] = useSearchParams();
  const invalidateMe = useInvalidateMe();
  const [done, setDone] = useState(false);
  const redirect = safeReturnTo(search.get("return_to"));
  useEffect(() => {
    authApi
      .logout()
      .catch(() => undefined)
      .then(() => invalidateMe())
      .finally(() => {
        setDone(true);
        if (redirect && !redirect.startsWith("/"))
          window.location.assign(redirect);
      });
  }, [invalidateMe, redirect]);
  return (
    <AuthShell branding={DEFAULT_BRANDING} title="Signed out">
      {done ? (
        <div className="flex flex-col gap-4">
          <Alert kind="success">You have been signed out.</Alert>
          <Link className="text-brand underline" to="/login">
            Sign in again
          </Link>
        </div>
      ) : (
        <Spinner label="Signing out" />
      )}
    </AuthShell>
  );
}
